import React from 'react';

import { useCurrentUser } from '@docavenue/components';
import { PatientUser } from '@/components/molecules/WithAuth/types';
import FontAwesomeIcon from '@/components/atoms/FontawesomeIcon/FontawesomeIcon';
import { useTranslation } from '@/src/i18n';

type Props = {
  centerId: string | undefined;
  profileId?: string;
};

const CenterFlag = ({ centerId, profileId }: Props) => {
  const { t } = useTranslation();
  const profiles =
    useCurrentUser<PatientUser>()?.userPatientInformation
      ?.userPatientProfiles ?? [];
  const isFavorite = profileId
    ? profiles
        .find(profile => profile.id === profileId)
        ?.favoriteCenters?.find(center => center.centerId === centerId)
        ?.centerId
    : profiles
        .reduce(
          (acc, val) => [...acc, ...(val?.favoriteCenters ?? [])],
          [] as { centerId?: string }[], // todo types - 👈 this is the correct type according to swagger (centerId may be undefined) - those undefined `centerId` should be filtered before the find below
        )
        .find(center => center.centerId === centerId)?.centerId;

  return isFavorite ? (
    <FontAwesomeIcon
      name="star:solid"
      className="h-5 w-5 flex-shrink-0"
      color="#F6E05E"
      aria-label={t('in_favorites')}
    />
  ) : null;
};

export default CenterFlag;
